import React from 'react';
import { Button, Form, Modal } from 'react-bootstrap';
import Group from '../Models/Group'

export interface RenameGroupModalProps {
    show:boolean;
    group:Group;
    didPressDone: () => void;
    didPressSave: (newName:string) => void;
}

type RenameGroupModalState = {
    newName:string;
}

class RenameGroupModal extends React.Component<RenameGroupModalProps,RenameGroupModalState> {
    constructor(props:RenameGroupModalProps){
        super(props)
        this.state = {
            newName:""
        }
    }

    didUpdateName(event:React.ChangeEvent<HTMLInputElement>){
        const name = event.target.value
        this.setState({newName:name})
    }

    render(){

        const originalName = this.props.group.name

        return (
            <Modal show={this.props.show} onHide={this.props.didPressDone}>
                <Modal.Header>
                    <Modal.Title>Edit Group: {originalName}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <Form.Group>
                            <Form.Label><strong>Rename</strong></Form.Label>
                            <Form.Control type="text" placeholder="Insert new group name..." onChange={this.didUpdateName.bind(this)} value={this.state.newName}/>
                            <Form.Text className="text-muted">* Group names must be unique</Form.Text>
                        </Form.Group>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="primary" onClick={this.props.didPressSave.bind(this,this.state.newName)}>Save</Button>
                    <Button variant="secondary" onClick={this.props.didPressDone}>Cancel</Button>
                </Modal.Footer>
            </Modal>
        )
    }
}

export default RenameGroupModal